

import React from 'react';









































const DEFAULT_SELECTED_ORGANISATION = {
  organisationId: null,
  billingEntityCode: null,
  includedAddonTypes: [],
  customAddonCosts: [],
  permissions: [],
  preferences: {},
  package: null
};

const defaults = {
  organisationMemberships: [],
  isShootsta: false,
  isShootstaEditor: false,
  isShootstaAdmin: false,
  isShootstaTechSuport: false,
  isShootstaSeniorEditor: false,
  isShootstaUser: false,
  isShootstaAccountManager: false,
  selectedOrganisation: DEFAULT_SELECTED_ORGANISATION,
  updateSelectedOrganisation: () => {},
  updateSelectedOrganisationData: () => {}
};

const authorisationContext = React.createContext(defaults);

export default authorisationContext;
export const AuthorisationContextConsumer = authorisationContext.Consumer;